<section class="w-full flex flex-col justify-center">
  <div class="control" [ngStyle]="controlStyles">
    @if (labelEnabled) {
      <blaze-element-label
        [color]="props?.style?.general?.title?.color1"
        [extendInputPadding]="elementContext?.extendInputPadding"
        [fontFamily]="props?.style?.labelBlock?.fontFamily"
        [fontSize]="props?.style?.labelBlock?.fontSize"
        [fontStyle]="props?.style?.labelBlock?.fontStyle"
        [fontWeight]="props?.style?.labelBlock?.fontWeight"
        [horizontalAlign]="props?.content?.title?.align?.horizontal"
        [icon]="props?.content?.title?.icon"
        [iconColor]="props?.content?.title?.iconColor?.color1"
        [iconPosition]="props?.content?.title?.iconPosition"
        [iconSize]="props?.style?.labelBlock?.iconSize"
        [isUsingOldPaddingStrategy]="isUsingOldPaddingStrategy"
        [lineHeight]="props?.style?.labelBlock?.lineHeight"
        [position]="props?.content?.title?.position"
        [tooltip]="props?.content?.title?.tooltip"
        [verticalAlign]="labelVerticalAlign"
        [width]="props?.content?.title?.width"
      >
        {{ labelText }}
      </blaze-element-label>
    }
    <div
      [id]="wrapperSectionKey"
      class="input"
      [class.multiline]="isParagraph"
      [class.rich-text]="isRichText"
      [ngStyle]="inputWrapperStyles"
      [class.validation-error]="hasValidationError"
      [class.readonly]="isReadonly"
      (click)="onAreaClicked($event)"
    >
      @if (prefix) {
        <span class="prefix">{{ prefix }}</span>
      }
      @switch (elementFormat) {
        @case ('duration') {
          <ng-container [ngTemplateOutlet]="defaultInputTpl" />
        }
        @case ('geopoint') {
          <ng-container [ngTemplateOutlet]="defaultInputTpl" />
        }
        @case ('markdown') {
          <div (click)="onAreaClicked($event)" class="w-full">
            @if (!isLiveEdit) {
              <div
                class="html-content element-content {{ elementKeyRoot }} {{ wrapperSectionKey }}"
                [tabIndex]="isReadonly ? -1 : 0"
                [innerHTML]="value | markdown"
                (focus)="onAreaFocused()"
              ></div>
            } @else {
              <ng-container [ngTemplateOutlet]="textareaInputTpl" />
            }
          </div>
        }
        @case ('paragraph') {
          <ng-container [ngTemplateOutlet]="textareaInputTpl" />
        }
        @case ('richText') {
          <div (click)="onAreaClicked($event)" class="w-full relative h-full">
            <div
              class="html-content element-content {{ elementKeyRoot }} {{
                wrapperSectionKey
              }} h-full"
              [style.visibility]="isLiveEdit ? 'hidden' : 'visible'"
              [tabIndex]="isReadonly ? -1 : 0"
              [innerHTML]="value | securityTrust: 'html'"
              (focus)="onAreaFocused()"
            ></div>
            @if (isLiveEdit) {
              <editor
                #editor
                [init]="editorConfig"
                [id]="editorKey"
                [initialValue]="$any(value)"
                class="html-content {{ elementKeyRoot }} h-full"
                [class.validation-error]="hasValidationError"
                (onChange)="onValueChanged($event)"
                (mousedown)="onEditorMousedown($event)"
              />
            }
          </div>
        }
        @case ('secureText') {
          <input
            #inputText
            [formControl]="formControl"
            [type]="secureFieldType"
            [step]="inputStep"
            [placeholder]="placeholder"
            [ngStyle]="inputStyles"
            [readonly]="isReadonly"
            [tabIndex]="isReadonly ? -1 : 0"
            (beforeinput)="secureFieldInputBeforeInputFn($event, formControl)"
            (focus)="isFocused = true; secureFieldTypeFocusFn(inputText, formControl)"
            (click)="secureFieldTypeFocusFn(inputText, formControl)"
            (blur)="isFocused = false; resetSecureFieldFormControlFn(formControl)"
            (keydown.enter)="onEnterPressed()"
          />
          @if (formControl.dirty) {
            <button
              (click)="changeSecureTextType()"
              blazeIconButton="skeleton"
              class="password-icon"
              [ngStyle]="passwordIconStyles"
            >
              <mat-icon svgIcon="icon_preview_16" [class.!hidden]="secureFieldType === 'text'" />
              <mat-icon
                svgIcon="icon_preview_hidden_16"
                [class.!hidden]="secureFieldType === 'password'"
              />
            </button>
          }
        }
        @default {
          <ng-container [ngTemplateOutlet]="defaultInputTpl" />
        }
      }

      @if (suffix) {
        <span class="suffix">{{ suffix }}</span>
      }
    </div>
  </div>

  @if (showErrorLabel) {
    <div class="validation" [ngStyle]="validationStyles">
      {{ errorLabel }}
    </div>
  }
</section>

<ng-template #defaultInputTpl>
  <input
    #inputText
    [formControl]="formControl"
    [type]="inputConfig.type"
    [step]="inputStep"
    [placeholder]="placeholder"
    [ngStyle]="inputStyles"
    [readonly]="isReadonly"
    [tabIndex]="isReadonly ? -1 : 0"
    [min]="minimum"
    [max]="maximum"
    (beforeinput)="onInputTransform($event, formControl)"
    (paste)="onInputPaste($event, formControl)"
    (focus)="isFocused = true"
    (blur)="isFocused = false; onInputBlur(formControl)"
    (keydown.enter)="onEnterPressed()"
  />
</ng-template>

<ng-template #textareaInputTpl>
  <div
    class="textarea-container"
    [ngStyle]="inputStyles"
    [ngClass]="textareaContainerClasses$ | async"
    [attr.data-grow-value]="formControl.value"
  >
    <textarea
      #textArea
      rows="1"
      [formControl]="formControl"
      [placeholder]="placeholder"
      [readonly]="isReadonly"
      [tabIndex]="isReadonly ? -1 : 0"
      (focus)="isFocused = true"
      (blur)="onAreaBlur()"
      ngPreserveWhitespaces
    ></textarea>
  </div>
</ng-template>
